/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'
import back from '../assets/images/back.svg'
import { Card } from 'primereact/card'
import { TabView, TabPanel } from 'primereact/tabview'
import AuditContainer from '../containers/AuditContainer'
import { useHistory } from 'react-router-dom'
import SwaggerUI from 'swagger-ui-react'
import 'swagger-ui-react/swagger-ui.css'
import { apiConstants } from '../_constants'
import FileViewer from 'react-file-viewer'

export default function LibraryComponent() {
  const history = useHistory()

  const redirectBackToPreviousPage = () => {
    history.goBack()
  }
  return (
    <div className="p-col-10 dashboard">
      <div className="dashboard--wrapper">
        <Card className="managecontent libratyCon">
          <div className="p-col-12 titleSec">
            <img src={back} alt={back} className="m-r-10 pointer" onClick={() => redirectBackToPreviousPage()} />
            <h4 className="display_1 m-b-0">Library</h4>
          </div>
          <div className="p-col-12">
            <TabView renderActiveOnly={false}>
              <TabPanel header="Architectural Diagram">
                <FileViewer
                  filePath={apiConstants.DOCUMENT_URL}
                  fileType={apiConstants.DOCUMENT_URL.split('.').pop()}
                />
              </TabPanel>
              <TabPanel header="API Details">
                <SwaggerUI url={apiConstants.SWAGGER_URL} />
              </TabPanel>
              <TabPanel header="Audit Details">
                <AuditContainer />
              </TabPanel>
            </TabView>
          </div>
        </Card>
      </div>
    </div>
  )
}
